export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';

export const AUTH_REHYDRATE_USER = 'AUTH_REHYDRATE_USER';
export const AUTH_REHYDRATE_USER_SUCCESS = 'AUTH_REHYDRATE_USER_SUCCESS';
export const AUTH_REHYDRATE_USER_FAIL = 'AUTH_REHYDRATE_USER_FAIL';

export const AUTH_AUTHENTICATE_USER = 'AUTH_AUTHENTICATE_USER';
export const AUTH_AUTHENTICATE_USER_SUCCESS = 'AUTH_AUTHENTICATE_USER_SUCCESS';
export const AUTH_AUTHENTICATE_USER_FAIL = 'AUTH_AUTHENTICATE_USER_FAIL';
